<template>
  <v-dialog v-bind="computedProps" v-on="computedListeners" v-model="showDialog">
    <v-card min-height="80%" min-width="80%">
      <v-toolbar elevation="2" color="primary" dark dense>
        <v-spacer/>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid class="ma-0 pa-2">
          <dd-sub-header>
            <span>以下の検索条件で絞り込む</span>
            <span style="float: right;">
              <dd-transparent-button :minWidth="140" @click="isConditionHide = !isConditionHide">
              <div v-if="!isConditionHide" class="condition-expansion">検索条件を閉じる<v-icon>mdi-chevron-up</v-icon></div>
              <div v-else class="condition-expansion">検索条件を開く<v-icon>mdi-chevron-down</v-icon></div>
              </dd-transparent-button>
            </span>
          </dd-sub-header>
          <div v-if="!isConditionHide" class="px-1 pt-0 pb-2 condition-area">
            <!--マスタの種類が選択されていないときのみ表示される。-->
            <div v-if="Boolean(this.mstKbn==='Unselected')">
              <v-row no-gutters>
                <v-col :cols="6">
                  <dd-text-box
                    label="キーワード"
                    v-model="searchText"
                    :length="100"
                    :valueType="ctypes.InputTypes.Free"/>
                </v-col>
              </v-row>
            </div>
            <!--営業所マスタ検索用-->
            <div v-if="Boolean(this.mstKbn===1)">
              <v-row no-gutters>
                <v-col :xs="6" :sm="6" :md="3" :lg="2" :xl="2" :cols="8" class="px-1">
                  <dd-text-box
                    label="営業所コード"
                    v-model="conditions.eigyoshoCd"
                    ref="eigyoshoCd"
                    :length="10"
                    :required="false"
                    inputType="tel"
                    :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12"  class="px-1">
                  <dd-text-box
                    label="営業所名称"
                    v-model="conditions.eigyoshoNm"
                    ref="eigyoshoNm"
                    :length="50"
                    :required="false"
                    :valueType="Ctrls.InputTypes.FullAngle"
                  />
                </v-col>
              </v-row>
            </div>
            <!--人員マスタ検索用-->
            <div v-if="Boolean(this.mstKbn===2)">
              <v-row no-gutters>
                <v-col :xs="6" :sm="6" :md="3" :lg="2" :xl="2" :cols="8" class="px-1">
                  <dd-text-box
                    label="人員コード"
                    v-model="conditions.jininCd"
                    :length="10"
                    :required="false"
                    inputType="tel"
                    :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-text-box
                    label="人員氏名"
                    v-model="conditions.jininNmSei"
                    :length="50"
                    :required="false"
                    :valueType="Ctrls.InputTypes.FullAngle"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="営業所コード/名称"
                    v-model="conditions.eigyoshoCd"
                    :length="100"
                    :required="false"
                    :readonly="eigyoshoReadOnly"
                    :valueType="Ctrls.InputTypes.Free"
                    item-value="eigyoshoCd"
                    item-text="eigyoshoNm"
                    titleText="営業所検索"
                    :headerList="headersEigyoshoList"
                    :itemList="filteredEigyoshoList"
                    :abbreviatedDisplay="abbreviatedDisplay"
                    :itemsPerPage="itemsPerPage"
                  />
                </v-col>
              </v-row>
            </div>
            <!--車両マスタ検索用-->
            <div v-if="Boolean(this.mstKbn===3)">
              <v-row no-gutters>
                <v-col :xs="6" :sm="6" :md="3" :lg="2" :xl="2" :cols="8" class="px-1">
                  <dd-text-box
                    label="車両番号"
                    v-model="conditions.sharyoNo"
                    :length="8"
                    :required="false"
                    inputType="tel"
                    :valueType="Ctrls.InputTypes.Alphanumeric"/>
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-text-box
                    label="車両表示名"
                    v-model="conditions.jidoshaHyojiNm"
                    :length="10"
                    :required="false"
                    :valueType="Ctrls.InputTypes.Free"/>
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="営業所コード/名称"
                    v-model="conditions.eigyoshoCd"
                    :length="100"
                    :required="false"
                    :readonly="eigyoshoReadOnly"
                    :valueType="Ctrls.InputTypes.Free"
                    item-value="eigyoshoCd"
                    item-text="eigyoshoNm"
                    titleText="営業所検索"
                    :headerList="headersEigyoshoList"
                    :itemList="filteredEigyoshoList"
                    :abbreviatedDisplay="abbreviatedDisplay"
                    :itemsPerPage="itemsPerPage"
                  />
                </v-col>
              </v-row>
            </div>
            <!--品名マスタ検索用-->
            <div v-if="Boolean(this.mstKbn===4)">
              <v-row no-gutters>
                <v-col :xs="6" :sm="6" :md="3" :lg="2" :xl="2" :cols="8" class="px-1">
                  <dd-text-box
                    label="品名コード"
                    v-model="conditions.hinmeiCd"
                    ref="hinmeiCd"
                    :length="10"
                    :required="false"
                    inputType="tel"
                    :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-text-box
                    label="品名"
                    v-model="conditions.hinmeiNm"
                    ref="hinmeiNm"
                    :length="80"
                    :required="false"
                    :valueType="Ctrls.InputTypes.FullAngle"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="得意先コード/名称"
                    v-model="conditions.torihikisakiCd"
                    ref="torihikisakiCd"
                    :length="100"
                    :required="false"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="得意先検索"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :headerList="headersTorihikisakiList"
                    :itemList="filteredTorihikisakiList"
                    :abbreviatedDisplay="abbreviatedDisplay"
                    :itemsPerPage="itemsPerPage"
                  />
                </v-col>
              </v-row>
            </div>
            <!--発着地マスタ検索用-->
            <div v-if="Boolean(this.mstKbn===5)">
              <v-row no-gutters>
                <v-col :xs="6" :sm="6" :md="3" :lg="2" :xl="2" :cols="8" class="px-1">
                  <dd-text-box
                    label="発着地コード"
                    v-model="conditions.hacchakuchiCd"
                    ref="hacchakuchiCd"
                    :length="16"
                    :required="false"
                    inputType="tel"
                    :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-text-box
                    label="発着地名"
                    v-model="conditions.hacchakuchiNm"
                    ref="hacchakuchiNm"
                    :length="100"
                    :required="false"
                    :valueType="Ctrls.InputTypes.FullAngle"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box-child
                    label="取引先コード/名称"
                    v-model="conditions.torihikisakiCd"
                    ref="torihikisakiCd"
                    :length="100"
                    :required="false"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="取引先検索"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :headerList="headersTorihikisakiList"
                    :itemList="filteredTorihikisakiList"
                    :abbreviatedDisplay="abbreviatedDisplay"
                    :itemsPerPage="itemsPerPage"
                  />
                </v-col>
              </v-row>
            </div>
            <!--取引先マスタ検索用-->
            <div v-if="Boolean(this.mstKbn===6)">
              <v-row no-gutters>
                <v-col :xs="6" :sm="6" :md="3" :lg="2" :xl="2" :cols="8" class="px-1">
                  <dd-text-box
                    label="取引先コード"
                    v-model="conditions.torihikisakiCd"
                    ref="torihikisakiCd"
                    :length="10"
                    :required="false"
                    inputType="tel"
                    :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="8" class="px-1">
                  <dd-text-box
                    label="取引先名称"
                    v-model="conditions.torihikisakiNm"
                    ref="torihikisakiNm"
                    :length="50"
                    :required="false"
                    :valueType="Ctrls.InputTypes.FullAngle"
                    />
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="8" class="px-1">
                  <dd-text-box
                    label="取引先名称カナ"
                    v-model="conditions.torihikisakiNmKana"
                    ref="torihikisakiNmKana"
                    :length="50"
                    :required="false"
                    :valueType="Ctrls.InputTypes.FullWidthKana"
                    />
                </v-col>
              </v-row>
            </div>

            <v-row class="mt-2" justify="center">
              <dd-custom-button
                :rounded="true"
                :minWidth="200"
                :large="true"
                @click="onSearchButtonClick">
                検索をする
              </dd-custom-button>
              <a class="condition-clear" @click="onClearButtonClick">
                条件をクリア
              </a>
            </v-row>
          </div>

          <div class="px-1 py-2" v-if="filteredRows.length > 0">
            <v-row no-gutters>
              <v-col :xs="5" :sm="5" :md="5" :lg="2" :xl="2" :cols="5" class="px-1">
                <span class="search-number">{{ filteredRows.length }}</span>件 の検索結果
              </v-col>
              <v-col :xs="7" :sm="7" :md="7" :lg="4" :xl="4" :cols="7" v-if="!abbreviatedDisplay">
                <a
                  class="condition-clear-bottom"
                  @click="onClearButtonClick">
                  条件をクリア
                </a>
              </v-col>
              <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="mt-2" v-if="!abbreviatedDisplay">
                <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
              </v-col>
              <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="px-1">
                <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
              </v-col>
            </v-row>

            <hr class="section-line mb-2">

            <v-row no-gutters justify="end" v-if="!abbreviatedDisplay">
              <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12">
                <div class="pt-2">
                  <dd-transparent-button
                    v-if="(targetMaster)"
                    :minWidth="265"
                    tooltipText="ここからマスタデータの新規登録が実行できます。<br>※別画面で起動します。"
                    :tooltipTop="true"
                    :enableToolTip="helpUseFlg"
                    @click="onAddMaster()">
                    <v-icon color="#1F2B38">mdi-plus-circle</v-icon>
                    <span style="padding-top: 2px;">新たにマスタデータを追加する場合はこちら</span>
                  </dd-transparent-button>
                </div>
              </v-col>
              <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12">
                <v-row no-gutters justify="end">
                  <dd-select-items-per-page
                    ref="pagination1"
                    :itemsPerPage.sync="itemsPerPage"
                    :currentPage.sync="page"
                    :items="filteredRows"
                    @changeItemsPerPage="changeItemsPerPage"
                    @changePage="changePage"
                  />
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-data-table
                item-key="id"
                :headers="headers"
                :items="filteredRows"
                :custom-filter="filtering"
                :search="searchText"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                @dblclick:row="onRowDoubleClick"
                no-data-text="対象データはありません"
                fixed-header
                :hide-default-header="abbreviatedDisplay"
                hide-default-footer
                locale="ja-jp"
                dense
              >
                <template v-slot:[`item.actions`]="{item}">
                  <template>
                    <v-chip
                      small
                      color="primary"
                      @click="onRowSelectButtonClick(item)"
                    >
                      選択
                    </v-chip>
                  </template>
                </template>
                <template v-slot:item="{ item }" v-if="abbreviatedDisplay">
                  <tr>
                    <td rowspan="1" style="width:20px" class="px-0 rireki-td">
                      <v-chip
                        small
                        color="primary"
                        @click="onRowSelectButtonClick(item)"
                      >
                        選択
                      </v-chip>
                    </td>
                    <!--営業所マスタ検索用-->
                    <template v-if="mstKbn === 1">
                      <td colspan="2" class="wrap-text rireki-td">
                        <div class="row-line">
                          <span class="label">営業所コード：</span>
                          <span class="value">{{ item.eigyoshoCd }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">営業所名称：</span>
                          <span class="value">{{ item.eigyoshoNm }}</span>
                        </div>
                      </td>
                    </template>
                    <!--人員マスタ検索用-->
                    <template v-if="mstKbn === 2">
                      <td colspan="2" class="wrap-text rireki-td">
                        <div class="row-line">
                          <span class="label">人員コード：</span>
                          <span class="value">{{ item.jininCd }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">人員氏名：</span>
                          <span class="value">{{ item.jininNmSei }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">営業所：</span>
                          <span class="value">{{ item.eigyoshoNm }}</span>
                        </div>
                      </td>
                    </template>
                    <!--車両マスタ検索用-->
                    <template v-if="mstKbn === 3">
                      <td colspan="2" class="wrap-text rireki-td">
                        <div class="row-line">
                          <span class="label">車両番号：</span>
                          <span class="value">{{ item.sharyoNo }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">車両表示名：</span>
                          <span class="value">{{ item.jidoshaHyojiNm }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">登録番号：</span>
                          <span class="value">{{ item.torokuNo }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">営業所：</span>
                          <span class="value">{{ item.eigyoshoNm }}</span>
                        </div>
                      </td>
                    </template>
                    <!--品名マスタ検索用-->
                    <template v-if="mstKbn === 4">
                      <td colspan="2" class="wrap-text rireki-td">
                        <div class="row-line">
                          <span class="label">品名コード：</span>
                          <span class="value">{{ item.hinmeiCd }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">品名名称：</span>
                          <span class="value">{{ item.hinmeiNm }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">得意先名称：</span>
                          <span class="value">{{ item.torihikisakiNm }}</span>
                        </div>
                      </td>
                    </template>
                    <!--発着地マスタ検索用-->
                    <template v-if="mstKbn === 5">
                      <td colspan="2" class="wrap-text rireki-td">
                        <div class="row-line">
                          <span class="label">発着地コード：</span>
                          <span class="value">{{ item.hacchakuchiCd }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">発着地名：</span>
                          <span class="value">{{ item.hacchakuchiNm }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">取引先名称：</span>
                          <span class="value">{{ item.torihikisakiNm }}</span>
                        </div>
                      </td>
                    </template>
                    <!--取引先マスタ検索用-->
                    <template v-if="mstKbn === 6">
                      <td colspan="2" class="wrap-text rireki-td">
                        <div class="row-line">
                          <span class="label">取引先コード：</span>
                          <span class="value">{{ item.torihikisakiCd }}</span>
                        </div>
                        <div class="row-line">
                          <span class="label">取引先名称：</span>
                          <span class="value">{{ item.torihikisakiNm }}</span>
                        </div>
                      </td>
                    </template>
                  </tr>
                </template>
              </v-data-table>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters class="px-1 py-0 mt-3" v-if="filteredRows.length > 0">
          <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12">
            <dd-transparent-button :minWidth="120" @click="onCloseClick">
              <v-icon color="#1F2B38">mdi-close-circle</v-icon>ヘルプを閉じる
            </dd-transparent-button>
          </v-col>
          <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12" v-if="!abbreviatedDisplay">
            <v-row no-gutters justify="end">
              <dd-select-items-per-page
                ref="pagination2"
                :itemsPerPage.sync="itemsPerPage"
                :currentPage.sync="page"
                :items="filteredRows"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdCodeTextBoxChild from './DdCodeTextBoxChild.vue'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'

import controls from '@/rahmen/controls'
import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'
import filter from '@/rahmen/utils/filters'
import modals from '@/ddv2.library/modals'
/**
 * @file DDv2用マスタ検索用ダイアログ
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [showDialog=false] - ダイアログ表示可否
 * @vue-prop {Array} headerList - ダイアログ用ヘッダリスト
 * @vue-prop {Array} itemList - オートコンプリート用リスト
 * @vue-prop {String} titleText - ダイアログ用表示タイトル
 * @see DdCodeTextBox
 * @example
    <dd-master-search-dialog
      :showDialog="showDialog"
      :titleText="titleText"
      :headerList="headerList"
      :itemList="itemList"
      [atmark]close="onDialogClosed"/>
 */
export default {
  mixins: [flowMixin],
  name: 'DdMasterSearchDialog',
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBoxChild,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 一覧内容
     */
    itemList: Array,
    /**
     * ヘッダー設定
     */
    headerList: Array,
    /**
     * ダイアログタイトル
     */
    titleText: String,
    /**
     * 対象マスタ
     */
    targetMaster: {
      type: String,
      default: 'Unselected'
    },
    /**
     * 初期セット取引先コード
     */
    initTorihikisakiCd: {
      type: String,
      default: ''
    },
    /**
     * 営業所ロックフラグ
     */
    eigyoshoReadOnly: {
      type: Boolean,
      default: false
    },
    /**
     * 初期セット営業所コード
     */
    initEigyoshoCd: {
      type: String,
      default: ''
    },
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 25
    }
  },
  data: () => ({
    isConditionHide: false,
    title: '',
    conditions: {
      eigyoshoCd: null,
      eigyoshoKbn: '00',
      eigyoshoNm: '',
      jininCd: null,
      jininNmSei: '',
      sharyoNo: '',
      jidoshaHyojiNm: '',
      hacchusakiFlgKubun: '0',
      torihikisakiCd: null,
      hinmeiCd: null,
      hinmeiNm: '',
      hacchakuchiCd: null,
      hacchakuchiNm: '',
      torihikisakiKbn: '0',
      torihikisakiNm: '',
      torihikisakiNmKana: ''
    },
    ddMasterSearchConditions: {
      eigyoshoCd: null,
      eigyoshoKbn: '00',
      eigyoshoNm: '',
      jininCd: null,
      jininNmSei: '',
      sharyoNo: '',
      jidoshaHyojiNm: '',
      hacchusakiFlgKubun: '0',
      torihikisakiCd: null,
      hinmeiCd: null,
      hinmeiNm: '',
      hacchakuchiCd: null,
      hacchakuchiNm: '',
      torihikisakiKbn: '0',
      torihikisakiNm: '',
      torihikisakiNmKana: ''
    },
    searchText: '',
    headers: [],
    rows: [],
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    ctypes: controls,
    mstKbn: 0,
    // 一覧選択用
    actionDefine: { text: '', value: 'actions', align: 'center' },
    // 一覧制御用
    selected: [],
    page: 1
  }),
  created () {
  },
  mounted () {
    this.title = this.titleText
  },
  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        scrollable: true,
        maxWidth: '80%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      kubunList: 'DDMasters/msysKubun',
      userEigyoshoCd: 'users/eigyoshoCd',
      anotherEigyoshoCtrlFlg: 'users/anotherEigyoshoCtrlFlg',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredEigyoshoKbn () {
      console.log('●filteredEigyoshoKbn')
      const listData = this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'KBN002'
      }).map(function (elem) {
        return elem
      })
      return listData
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredTorihikisakiList () {
      // 得意先を出力
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredRows () {
      const self = this
      return this.rows.filter(function (elem) {
        return self.isDdMasterSearch(elem)
      })
    }
  },
  methods: {
    onRowDoubleClick: function (e, f) {
      console.log('onRowDoubleClick', e, f)
      this.$emit('close', f.item)
    },
    onRowSelectButtonClick: function (item) {
      console.log('onRowSelectButtonClick', item)
      this.$emit('close', item)
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event close
       * @type {Event}
       */
      this.$emit('close', undefined)
    },
    onAddMaster: function () {
      var path = location.href
      path = path.substring(0, path.indexOf('#/'))
      const mstNm = this.targetMaster === 'sharyoNo' ? 'sharyo' : this.targetMaster
      var url = path + '#/mst/' + mstNm + '/edit/0'
      window.open(url, '_blank')
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
        this.searchText = ''
        this.rows = this.itemList
      })
      this.Effects.loadComplete()
    },
    onSearchButtonClick: function (e) {
      this.ddMasterSearchConditions = Object.assign({}, this.conditions)
    },
    isDdMasterSearch (elem) {
      const self = this
      return (!self.ddMasterSearchConditions.eigyoshoCd || elem.eigyoshoCd === self.ddMasterSearchConditions.eigyoshoCd) &&
      (self.ddMasterSearchConditions.eigyoshoKbn === '00' || elem.eigyoshoKbn === self.ddMasterSearchConditions.eigyoshoKbn) &&
      (!self.ddMasterSearchConditions.eigyoshoNm || elem.eigyoshoNm.indexOf(self.ddMasterSearchConditions.eigyoshoNm) !== -1) &&
      (!self.ddMasterSearchConditions.jininCd || elem.jininCd === self.ddMasterSearchConditions.jininCd) &&
      (!self.ddMasterSearchConditions.jininNmSei || elem.jininNmSei.indexOf(self.ddMasterSearchConditions.jininNmSei) !== -1) &&
      (!self.ddMasterSearchConditions.sharyoNo || String(elem.sharyoNo).indexOf(self.ddMasterSearchConditions.sharyoNo) !== -1) &&
      (!self.ddMasterSearchConditions.jidoshaHyojiNm || elem.jidoshaHyojiNm.indexOf(self.ddMasterSearchConditions.jidoshaHyojiNm) !== -1) &&
      (self.ddMasterSearchConditions.hacchusakiFlgKubun === '0' || elem.hacchusakiFlgKubun === self.ddMasterSearchConditions.hacchusakiFlgKubun) &&
      (!self.ddMasterSearchConditions.torihikisakiCd || elem.torihikisakiCd === self.ddMasterSearchConditions.torihikisakiCd) &&
      (!self.ddMasterSearchConditions.hinmeiCd || elem.hinmeiCd === self.ddMasterSearchConditions.hinmeiCd) &&
      (!self.ddMasterSearchConditions.hinmeiNm || elem.hinmeiNm.indexOf(self.ddMasterSearchConditions.hinmeiNm) !== -1) &&
      (!self.ddMasterSearchConditions.hacchakuchiCd || elem.hacchakuchiCd === self.ddMasterSearchConditions.hacchakuchiCd) &&
      (!self.ddMasterSearchConditions.hacchakuchiNm || elem.hacchakuchiNm.indexOf(self.ddMasterSearchConditions.hacchakuchiNm) !== -1) &&
      (self.ddMasterSearchConditions.torihikisakiKbn === '0' ||
      (self.ddMasterSearchConditions.torihikisakiKbn === '1' && elem.tokuisakiFlg === true) ||
      (self.ddMasterSearchConditions.torihikisakiKbn === '2' && elem.shiiresakiFlg === true) ||
      (self.ddMasterSearchConditions.torihikisakiKbn === '3' && elem.hacchusakiFlg === true)) &&
      (!self.ddMasterSearchConditions.torihikisakiNm || elem.torihikisakiNm.indexOf(self.ddMasterSearchConditions.torihikisakiNm) !== -1) &&
      (!self.ddMasterSearchConditions.torihikisakiNmKana || elem.torihikisakiNmKana.indexOf(self.ddMasterSearchConditions.torihikisakiNmKana) !== -1)
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.rows = this.itemList
      this.headers = Object.assign([], this.headerList)
      // 先頭に選択ボタンを追加
      this.headers.splice(0, 0, this.actionDefine)
      let setEigyoshoCd = null
      let setTorihikisakiCd = null
      if (this.targetMaster === 'eigyosho') {
        this.mstKbn = 1
      } else if (this.targetMaster === 'jinin') {
        this.mstKbn = 2
      } else if (this.targetMaster === 'sharyoNo') {
        this.mstKbn = 3
      } else if (this.targetMaster === 'hinmei') {
        this.mstKbn = 4
      } else if (this.targetMaster === 'hacchakuchi') {
        this.mstKbn = 5
      } else if (this.targetMaster === 'torihikisaki') {
        this.mstKbn = 6
      } else {
        this.mstKbn = 0
      }
      // 営業所コードが条件に入っているマスタについては、初期値としてloginUserInfoの営業所コードをセットする。
      if (([2, 3]).includes(this.mstKbn)) {
        setEigyoshoCd = this.initEigyoshoCd ? this.initEigyoshoCd : this.userEigyoshoCd
        console.log(this.anotherEigyoshoCtrlFlg)
      // 取引先コードが条件に入っているマスタについては、初期値として画面で選択された取引先コードをセットする。
      } else if (([4, 5]).includes(this.mstKbn)) {
        setTorihikisakiCd = this.initTorihikisakiCd ? this.initTorihikisakiCd : null
      }
      const initConditions = {
        eigyoshoCd: setEigyoshoCd,
        eigyoshoKbn: '00',
        eigyoshoNm: '',
        jininCd: null,
        jininNmSei: '',
        sharyoNo: '',
        jidoshaHyojiNm: '',
        hacchusakiFlgKubun: '0',
        torihikisakiCd: setTorihikisakiCd,
        hinmeiCd: null,
        hinmeiNm: '',
        hacchakuchiCd: null,
        hacchakuchiNm: '',
        torihikisakiKbn: '0',
        torihikisakiNm: '',
        torihikisakiNmKana: ''
      }
      this.conditions = Object.assign({}, initConditions)
      this.ddMasterSearchConditions = Object.assign({}, initConditions)
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 600 !important;
}
</style>
